module.exports = __webpack_public_path__ + "img/keyboard_65_less_split.f4ef7e0b.png";